import { Card, CardBody, Col } from "reactstrap";
import { LabelText } from "../../Utils/Input";
import { handleEffectiveAtDate } from "./constants/initialValues";
import CommonDateTimePicker from "../../Utils/CommonDateTimePicker";
import { useContext } from "react";
import { CreateOfferContext } from "./context";

export const EffectiveAt = () => {
  const { touched, values, errors, setFieldTouched, setFieldValue } =
    useContext(CreateOfferContext);
    const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";
  return (
    <Col xxl={4} md={6} className="mt-0">
      <LabelText
        htmlFor={"effectiveAt"}
        className={"text-danger"}
        displayText={"Effective Date"}
        important={"*"}
      />
      <LabelText
        htmlFor={"effectiveAt"}
        classLabelName={`d-block ms-0 rv-sub-label ${
          touched.effectiveAt && errors.effectiveAt
            ? "rv-label-danger"
            : "rv-label-muted"
        } `}
        displayText={
          touched.effectiveAt && errors.effectiveAt
            ? errors.effectiveAt
            : dateFormat
        }
      />
      <CommonDateTimePicker
        className={`form-control ${
          touched?.effectiveAt && !values?.effectiveAt ? "error-input" : ""
        }`}
        value={values?.effectiveAt}
        name={`effectiveAt`}
        handleChange={handleEffectiveAtDate(setFieldTouched, setFieldValue)}
        format={dateFormat}
        views={["year", "month", "day"]}
        style={{
          height: "38px",
          fontSize: "0.875rem",
          borderRadius: "0.5rem",
        }}
        placeholder={" "}
      />
    </Col>
  );
};
